const contactPage = () => {

    const allInputs = document.querySelectorAll('.contact__form-textarea textarea, .contact__form-input input');

    if(allInputs) {
        for(let i = 0; i < allInputs.length; i++) {
            if(allInputs[i].value.length > 0) {
                allInputs[i].classList.add('active');
            } else {
                allInputs[i].classList.remove('active');
            }
            allInputs[i].addEventListener('change',function() {
                if(this.value.length > 0) {
                    this.classList.add('active');
                } else {
                    this.classList.remove('active');
                }
            })
        }
    }


    const contactForm = document.querySelector('.contact__form');
    let statusWrapperMain = document.querySelector('.contact__wrapper-status-info');
    let statusWrapper = document.querySelector('.contact__wrapper-status-info-text');
    let sendingContact = false;

    if (contactForm) {
        const contactSubmit = contactForm.querySelector("input[type='submit']");
        const body = document.querySelector("body");
        contactForm.addEventListener('submit',function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (!sendingContact) {
                sendingContact = true;
                body.classList.add("loading");
                statusWrapperMain.classList.remove('show');
                statusWrapperMain.classList.remove('error');
                fetch("/api/v1/contact/", {
                    method: "POST",
                    body: new FormData(this),
                })
                    .then(res => res.json())
                    .then(
                        result => {
                            console.log(result);
                            if(result.status === true) {
                                if(statusWrapper) {
                                    statusWrapperMain.classList.add('show');
                                    statusWrapperMain.classList.add('success');
                                    statusWrapper.innerHTML = result.message.send;
                                    body.classList.remove("loading");
                                    contactSubmit.disabled = true;
                                    sendingContact = false;
                                    window.scrollTo(0,0);
                                }
                            }
                            else {
                                if(statusWrapper) {
                                    statusWrapperMain.classList.add('show');
                                    statusWrapperMain.classList.add('error');
                                    const messageArr = [];
                                    for (let message in result.message) {
                                        if (result.message.hasOwnProperty(message)) {
                                            messageArr.push(result.message[message]);
                                        }
                                    }
                                    statusWrapper.innerHTML = messageArr.join(", ");
                                    sendingContact = false;
                                    body.classList.remove("loading");
                                    window.scrollTo(0,0);
                                }
                            }
                        }
                    )
                    .catch(err => console.log(err))
            }
        })
    }
}

export default contactPage;
